import { render, staticRenderFns } from "./GASlot.vue?vue&type=template&id=0d523400"
import script from "./GASlot.vue?vue&type=script&lang=js"
export * from "./GASlot.vue?vue&type=script&lang=js"
import style0 from "./GASlot.vue?vue&type=style&index=0&id=0d523400&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports